import React from 'react';
import {Route, Routes} from 'react-router-dom';
import Home from './components/Home';
import NoMatch from './components/NoMatch';

export default function Router() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="*" element={<NoMatch />} />
    </Routes>
  );
}
